__turbopack_context__.v({
  "className": "generalsans_703b8c3c-module__dvgULa__className",
  "variable": "generalsans_703b8c3c-module__dvgULa__variable",
});
